import { render, staticRenderFns } from "./BulkDispatchImportDialog.vue?vue&type=template&id=70b0dd46&"
import script from "./BulkDispatchImportDialog.vue?vue&type=script&lang=js&"
export * from "./BulkDispatchImportDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports